import type { FC } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Alert, Button, Dialog } from '@/ui';

import { resolveApiErrorMessage } from '../../lib/apiError';
import { useReturnShipmentToPreparation } from './api/mutations';

/*
 * «Назад по этапу» из «Доставки» - подтверждение: «Доставка» -> «Подготовка».
 * Откатывает ошибочную передачу в доставку, пока 1С не отгрузила заказ (ADR-013):
 * дальше этап ведёт заказ - это отсекает сервер (409), а кнопку прячет карточка.
 */

export interface ReturnToPreparationDialogProps {
  shipmentId: string;
  shipmentNumber: number | string;
  onClose: () => void;
}

export const ReturnToPreparationDialog: FC<ReturnToPreparationDialogProps> = ({
  shipmentId,
  shipmentNumber,
  onClose,
}) => {
  const returnToPreparation = useReturnShipmentToPreparation();

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={`Вернуть отгрузку № ${shipmentNumber} в «Подготовку»`}
      footer={
        <>
          <Button onClick={onClose}>Не возвращать</Button>
          <Button
            variant="primary"
            disabled={returnToPreparation.isPending}
            onClick={() =>
              returnToPreparation.mutate(
                { path: { id: shipmentId } },
                { onSuccess: onClose },
              )
            }
          >
            <ArrowLeft aria-hidden /> Вернуть в «Подготовку»
          </Button>
        </>
      }
    >
      <p className="m-0 text-[13px] text-ink-700">
        Отгрузка вернётся из «Доставки» в «Подготовку», как до «Передать в
        доставку». Трек-номер и дата отгрузки останутся.
      </p>
      {returnToPreparation.isError && (
        <Alert tone="error" className="mt-3.5">
          Не удалось вернуть:{' '}
          {resolveApiErrorMessage(returnToPreparation.error)}
        </Alert>
      )}
    </Dialog>
  );
};
